import { inject, Injectable } from '@angular/core'
import { FeathersService } from '../feathers.service'
import { from, Observable } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { SocialServiceHandleEnum } from '../../shared/enums/social-service-handles.enum'

export interface ActiveAllocationManagerPayload {
  socialServiceId: number
  locationId: number
}

export interface ActiveAllocationCurrentUser {
  allocationId: number
  socialServiceId: number
  locationId: number
  handle?: SocialServiceHandleEnum
}

@Injectable({
  providedIn: 'root',
})
export class ActiveAllocationManagerService {
  private feathersService = inject(FeathersService)

  private readonly service = 'features/active-allocation-manager'

  set(socialServiceId: number, locationId: number): Observable<any> {
    const payload: ActiveAllocationManagerPayload = { socialServiceId, locationId }
    const service = this.feathersService.service(this.service)
    return from(service.create(payload)).pipe(
      map((response: any) => response),
      catchError((error) => {
        console.error('Error in ActiveAllocationManagerService:', error)
        throw error
      }),
    )
  }

  get(): Observable<ActiveAllocationCurrentUser[]> {
    const service = this.feathersService.service(this.service)
    return from(service.find()).pipe(
      map((response: any) => {
        console.log('Service response:', response)
        return response.data || response
      }),
      catchError((error) => {
        console.error('Error in ActiveAllocationManagerService (get):', error)
        throw error
      }),
    )
  }
}
